import { render, staticRenderFns } from "./DefaultSidebarHeader.vue?vue&type=template&id=20fd5d23&"
import script from "./DefaultSidebarHeader.vue?vue&type=script&lang=js&"
export * from "./DefaultSidebarHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports